import Button from "./Button/Button";
import TextBox from "./TextBox/TextBox";
import RadioLabel from "./Radio/RadioLabel";
import { InputType } from "../../../types";
import DateTime from "./DateTime/DateTime";
import CheckboxGroup from "./Checkbox/CheckboxGroup";
import FileUpload from "./FileUpload/FileUpload";
import Link from "./Link/Link";
import Checkbox from "./Checkbox/Checkbox";
import AccordionDateTime from "./AccordionDateTime/AccordionDateTime";
import AccordionCheckboxGroup from "./AccordionCheckboxGroup/AccordionCheckboxGroup";
import {
	AccordionCheckboxGroupPropsInterface,
	AccordionDateTimePropsInterface,
	MvButtonPropsInterface,
	MvInputInterface,
	MvLinkPropsInterface,
} from "./types";
import ButtonGroup from "./Button/ButtonGroup";
import SliderRange from "./Slider/SliderRange";
import DateRangeComp from "./DateRange/DateRange";

const MvInput = (
	props:
		| MvInputInterface
		| MvLinkPropsInterface
		| MvButtonPropsInterface
		| AccordionCheckboxGroupPropsInterface
		| AccordionDateTimePropsInterface
) => {
	let inputElement = null;
	const controls = props;

	switch (controls.elementType) {
		case InputType.RADIO_LABEL:
			inputElement = <RadioLabel {...controls} />;
			break;
		case InputType.INPUT:
			inputElement = <TextBox {...controls} />;
			break;
		case InputType.BUTTON:
			inputElement = <Button {...controls} />;
			break;
		case InputType.BUTTON_CHECKBOX_GROUP:
			inputElement = <ButtonGroup {...controls} />;
			break;
		case InputType.BUTTON_RADIO_GROUP:
		case InputType.BUTTON_RADIO_DATE_GROUP:
			inputElement = <ButtonGroup {...controls} isRadio />;
			break;
		case InputType.LINK:
			inputElement = <Link {...controls} />;
			break;
		case InputType.DATE_TIME:
			inputElement = <DateTime {...controls} />;
			break;
		case InputType.DATE_RANGE:
			inputElement = <DateRangeComp {...controls} />;
			break;
		case InputType.CHECKBOX_GROUP:
			inputElement = <CheckboxGroup {...controls} />;
			break;
		case InputType.CHECKBOX:
			inputElement = <Checkbox {...controls} />;
			break;
		case InputType.ACCORDION_CHECKBOX_GROUP:
			inputElement = <AccordionCheckboxGroup {...controls} />;
			break;
		case InputType.ACCORDION_DATE_TIME:
			inputElement = <AccordionDateTime {...controls} />;
			break;
		case InputType.RANGE_SLIDER:
			inputElement = <SliderRange {...controls} />;
			break;
		case InputType.FILE:
			inputElement = <FileUpload {...controls} />;
			break;

		default:
			throw Error(`${(controls as any).elementType as string} - Is not supported by system yet`);
	}

	return inputElement;
};

export default MvInput;
